import Animation from "./scripts/animation";
import Accordion from "./scripts/components/accordion";
import Header from "./scripts/components/header";
import Infobox from "./scripts/components/infobox";
import Jumpmarks from "./scripts/components/jumpmarks";
import Modal from "./scripts/components/modal";
import Parallax from "./scripts/components/parallax";
import PDFLinks from './scripts/pdf-links'
import Slider from "./scripts/components/slider";
import Story from "./scripts/components/story";
import ViewportWatcher from './scripts/viewport-watcher';

import "./scripts/components/illu";
import "./scripts/crossfade";

const viewportwatcher = new ViewportWatcher();

const animation = new Animation(viewportwatcher);
const accordion = new Accordion();
const header = new Header();
const infobox = new Infobox();
const jumpmarks = new Jumpmarks(viewportwatcher);
const modal = new Modal();
const parallax = new Parallax();
const pdflinks = new PDFLinks()
const slider = new Slider();
const story = new Story();
